<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Movimientos de caja</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-if="puedeIngresar || puedeEgresar" type="button" @click="crear" class="btn-primary">
            <i class="fa fa-plus"></i><span>Nuevo</span>
          </button>
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <div class="form-inline__title">
                Fecha
              </div>
              <div class="form-inline__content">
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="H" />
                  <span>Hoy</span>
                </label>
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="A" />
                  <span>Ayer</span>
                </label>
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="P" />
                  <span>Personalizado</span>
                </label>
                <div class="form-field" v-show="form.tipoFecha == 'P'">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker id="desde" v-model="form.fechaDesde" locale="es" only-date no-label
                      noClearButton button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                      label="Seleccione fecha..." />
                    <label>Desde:</label>
                  </div>
                </div>
                <div class="form-field" v-show="form.tipoFecha == 'P'">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker id="hasta" v-model="form.fechaHasta" locale="es" only-date no-label
                      noClearButton button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                      label="Seleccione fecha..." />
                    <label>Hasta:</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <div class="form-inline__title">Estado</div>
              <div class="form-inline__content">
                <label>
                  <input v-model="form.estado" type="radio" value="A" />
                  <span>Activos</span>
                </label>
                <label>
                  <input v-model="form.estado" type="radio" value="I" />
                  <span>Inactivos</span>
                </label>
                <label>
                  <input v-model="form.estado" type="radio" value="T" />
                  <span>Todos</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." id="tipo_movimiento_filter" v-model="form.tipo_movimiento"
                  :options="tiposMovimiento" index="value"></v-select>
                <label for="tipo_movimiento_filter">Tipo de movimiento</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." id="tipo_caja_filter" v-model="form.tipo_caja"
                  :options="tiposCaja" index="value"></v-select>
                <label for="tipo_caja">Tipo de caja</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." id="rutas_filter" v-model="form.rutas_id" :options="rutas"
                  label="descripcion" index="id" selectedLabel="Seleccionado"
                  selectLabel="Presiona enter para seleccionar" deselectLabel="Presiona enter para eliminar"
                  multiple></v-select>
                <label for="ruta_id">Ruta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field v-model="form.searchP" id="buscar" placeholder="Realice una consulta...">
                Buscar
              </input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table :createButton="false"
          :editButton="puedeEditarMovimiento"
          :buscarButton="false" deleteButton :path="path" :columns="columns"
          :params="form" @editar="editar" @eliminar="eliminar" ref="movimientos"></k-table>
      </div>
    </div>
    <modal name="movimiento" scrollable resizable reset adaptive height="auto" width="60%" :clickToClose="false">
      <movimiento-prestamo :tiposCaja="tiposCaja" :tiposMovimiento="tiposMovimiento" :rutas="rutas" @cancelar="cancelar"
        @saved="saved" v-model="selected"></movimiento-prestamo>
    </modal>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import MovimientoPrestamo from "./MovimientoPrestamo.vue";
export default {
  components: {
    MovimientoPrestamo,
  },
  props: {
    puedeIngresar: {
      type: Boolean,
      required: false,
      default: false
    },
    puedeEgresar: {
      type: Boolean,
      required: false,
      default: false
    },
    puedeAnularIngreso: {
      type: Boolean,
      required: false,
      default: false
    },
    puedeAnularEgreso: {
      type: Boolean,
      required: false,
      default: false
    },
    puedeEditarMovimiento: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      path: url + "/prestamos/movimientos",
      selected: null,
      tiposCaja: [],
      tiposMovimiento: [],
      rutas: [],
      columns: [
        {
          display: 'Fecha',
          value: 'fecha',
        },
        {
          display: 'Tipo caja',
          value: 'tipo_caja_parse',
        },
        {
          display: 'Tipo de movimiento',
          value: 'tipo_movimiento_parse',
        },
        {
          display: 'Ruta',
          value: 'ruta.descripcion',
        },
        {
          display: 'Valor',
          value: 'valor',
          numeric: true,
          prefijo: '$'
        },
        {
          display: 'Observación',
          value: 'observacion',
        },
        {
          display: 'Estado',
          value: 'estado',
        }
      ],
      form: {
        tipo_consulta: "C",
        estado: "T",
        searchP: "",
        tipo_caja: "",
        tipo_movimiento: "",
        rutas_id: [],
        tipoFecha: "H",
        fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
        fechaHasta: moment(new Date()).format('YYYY-MM-DD')
      },
    };
  },
  methods: {
    consultar: function () {
      this.form.tipo_consulta = 'C';
      this.$refs.movimientos.loadRows();
    },
    cargarDatos: function () {
      axios
        .get(url + "/prestamos/movimientos/datos")
        .then(({ data }) => {
          this.tiposCaja = data.tiposCaja;
          this.tiposMovimiento = data.tiposMovimiento;
          this.rutas = data.rutas;
        })
        .catch(() => {
          swal("Hubo un error al cargar los datos.", "Error", "error");
        });
    },
    cancelar: function () {
      this.$modal.hide("movimiento");
    },
    saved: function () {
      this.$modal.hide("movimiento");
      this.$refs.movimientos.loadRows();
    },
    crear: function () {
      this.selected = {
        fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        tipo_caja: "R",
        tipo_movimiento: "E",
        ruta_id: "",
        valor: 0,
        observacion: ''
      };
      this.$modal.show("movimiento");
    },
    editar: function (movimiento) {
      this.selected = {
        id: movimiento.id,
        fecha: moment(movimiento.fecha).format("YYYY-MM-DD HH:mm:ss"),
        tipo_caja: movimiento.tipo_caja,
        tipo_movimiento: movimiento.tipo_movimiento,
        ruta_id: movimiento.ruta_id,
        valor: movimiento.valor,
        observacion: movimiento.observacion
      };
      this.$modal.show("movimiento");
    },
    eliminar: function (movimiento) {
      swal({
        title: "¿Deseas anular el movimiento de caja seleccionado?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/prestamos/movimientos/" + movimiento.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El movimiento ha sido anulado exitósamente.",
                "Realizado",
                "success"
              );
              this.$refs.movimientos.loadRows();
            })
            .catch(({ response }) => {
              const status = response.status;
              if (status == 409) {
                swal("Aviso", response.data.error, "warning");
                return;
              }
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    exportar: function () {
      this.form.tipo_consulta = 'E';
      let queryString = this.serialize(this.form);
      let urlApi = this.path + queryString;
      window.open(urlApi, '_blank');
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
  },
  mounted: function () {
    this.cargarDatos();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/movimientos/ListaMovimientosPrestamos.vue